import { Component, OnInit, Input } from '@angular/core';
import { CandidateData } from '../../candidateData';
import { AuthService } from 'src/app/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  @Input() candidateData: CandidateData;

  constructor(private auth: AuthService, private router: Router) { }

  ngOnInit() {
  }
 
  signOut() {
    localStorage.clear()
    this.auth.signOut();
    this.router.navigate(['/sign-in'])
  }

}
